import React from 'react'
import { useTranslation, Trans } from 'react-i18next';

function PopupMessage() {
    const { t } = useTranslation();
    return(
        <div id="knsl-success" className="knsl-popup">
            <img src="assets/img/features/12.svg" alt="success" className="knsl-succes-icon" />
            <h2 className="knsl-mb-20">{t('main.success')}</h2>
            <p><Trans i18nKey="main.messageSent">
                Your message has been sent successfully.<br/> We'll contact you very soon
            </Trans></p>
        </div>
    )
}

function PopupFrame() {
    const { t } = useTranslation();
    return(
        <div className="knsl-popup-frame">
            <div className="knsl-book-form knsl-book-popup">
                <span className="knsl-close-popup">+</span>
                <h2 className="knsl-mb-40">{t('main.searchYourRoom')}</h2>
                <form action='/rooms'>
                <div className="row">
                    <div className="col-lg-12">
                    <div className="knsl-input-frame">
                        <label>{t('main.checkIn')}</label>
                        <input type="text" className="datepicker-here" data-position="bottom left" placeholder="Select date" autoComplete="off" readOnly />
                    </div>
                    </div>
                    <div className="col-lg-12">
                    <div className="knsl-input-frame">
                        <label className="knsl-add-icon">{t('main.checkOut')}</label>
                        <input type="text" className="datepicker-here" data-position="bottom left" placeholder="Select date" autoComplete="off" readOnly />
                    </div>
                    </div>
                    <div className="col-6">
                    <div className="knsl-select-frame">
                        <label>{t('main.person')}</label>
                        <select className='nice-select'>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4" disabled>4</option>
                        </select>
                    </div>
                    </div>
                    <div className="col-6">
                    <div className="knsl-select-frame">
                        <label>{t('main.children')}</label>
                        <select className='nice-select'>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4" disabled>4</option>
                        </select>
                    </div>
                    </div>
                    <div className="col-lg-12 knsl-center">
                        <button type="submit" className="knsl-btn"><img src="assets/img/icons/search.svg" className="knsl-zoom" alt="icon" />{t('main.searchRoom')}</button>
                    </div>
                </div>
                </form>

            </div>
            </div>
    )
}

export {PopupFrame, PopupMessage}